import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { ResponseCertificateHistorical } from 'shell/models/response-certificate-historical';

export const transformResponseRequestCertificateHistorical = (
  response: AxiosResponse<HttpResponse<ResponseCertificateHistorical>>
): HttpResponse<ResponseCertificateHistorical> => {
  return response.data;
};
